import React, { useEffect } from 'react';

// Short-lived success badge (e.g. "Proposal Saved") — auto-dismisses itself
// after `duration` so callers don't need their own timeout bookkeeping.
// Renders inline where it's placed (not a fixed-position overlay) so callers
// can anchor it right above the relevant section of the page.
const Toast = ({ message, visible, duration = 4000, onDismiss }) => {
  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(onDismiss, duration);
    return () => clearTimeout(timer);
  }, [visible, duration, onDismiss]);

  if (!visible) return null;

  return (
    <div style={styles.toast}>
      {message}
    </div>
  );
};

const styles = {
  toast: {
    display: 'inline-block',
    backgroundColor: '#475569',
    color: '#FFFFFF',
    padding: '8px 16px',
    borderRadius: '20px',
    fontWeight: 'bold',
    fontSize: '0.85rem',
    fontFamily: '"Inter", sans-serif',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    marginBottom: '10px'
  }
};

export default Toast;
